import styled from 'styled-components'
import { GeoJSON, GeoJSONProps } from 'react-leaflet'
import { theme } from '../../../config'

type Props = GeoJSONProps & {
  color: string
  intensity?: keyof typeof theme.colors.gray
}

const colors = theme.colors as typeof theme.colors & {
  [key: string]: { [key: number]: string } | string | undefined
}

export const LayerGeoJSON = styled(GeoJSON).attrs(({ color, intensity = 500 }: Props) => ({
  style: {
    color: colors[color]?.[intensity] ?? colors[color] ?? color,
    fillColor: colors[color]?.[intensity] ?? colors[color] ?? color,
  },
}))<Props>``
